import { assignFormålToLastDrawing } from './map/draw';

export const formål = [];

const input = document.getElementById('formål');
const datalist = document.getElementById('formålList');

export const retrieveCode = () => {
  const v = input.value;
  const selectedOption = datalist.querySelector(`option[value="${v}"]`);
  return selectedOption ? selectedOption.dataset.code : null;
};

const fillInSelector = () => {
  const ua = navigator.userAgent;
  const epiphany = ua.includes('AppleWebKit') && ua.includes('Version');
  formål.forEach((f, i) => {
    if (i > 0 && f.initialverdi > 999) { // skip header and old codes from 1985
      const o = document.createElement('option');
      // o.value = f.initialverdi;
      o.value = f.kode;
      const ik = `[${f.initialverdi}] ${f.kode}`;
      o.innerHTML = `${ik} | ${f.kat_niva2}`;
      if (epiphany) o.value = ik; // otherwise it will not find codes
      o.title = f.beskrivelse || f.hovedformål;
      o.dataset.code = f.initialverdi; // only store code for feature update
      o.dataset.type = f.datakilde; // to be able to filter afterwards
      // // To be able to proceed when Nåværende is default choice:
      // if (i === 1) o.selected = true; // did not work
      datalist.appendChild(o);
      // if (i === 1) input.value = o.value; // did not work
    }
  });
  input.onchange = () => assignFormålToLastDrawing(retrieveCode()); // not FF
  // input.oninput = () => assignFormålToLastDrawing(retrieveCode());
};

export const filterDatalist = (type) => {
  // datalist.options only gives you enabled elements
  const l = datalist.children.length;
  for (let i = 0; i < l; i++) {
    const o = datalist.children.item(i);
    o.disabled = (o.dataset.type !== type);
  }
};

export const load = () => {
  // const fr = new FileReader();
  // fr.onload = csv => {
    const lines = csv.split(/\r?\n/); // split new line, both Linux and Win
    const header = [];
    lines.forEach(line => {
      if (!line) return;
      if (header.length === 0) {
        line.split(';').forEach(column => header.push(column));
        return; // continue to next line
      }
      const row = {};
      const s = line.split(';');
      (s.length === header.length) && s.forEach((v, i) => row[header[i]] = v);
      formål.push(row);
    });
  // };
  // fr.readAsText(new File(['csv'], 'csv/formål.csv', { type: "text/plain" }));
  fillInSelector();
};

export const translate = (code) => {
  const l = formål.length;
  for (let i = 0; i < l; i++) {
    const row = formål[i];
    if (Number(row.initialverdi) === Number(code))
      return `[${row.initialverdi}] ${row.kode}`;
  }
  return code;
};

export const getKat = (code, type) => {
  const l = formål.length;
  for (let i = 0; i < l; i++) {
    const row = formål[i];
    if (Number(row.initialverdi) === Number(code) && row.datakilde === type)
      return [row.kat_niva1, row.kat_niva2];
  }
  return '';
};

// \copy (
//   SELECT
//     -- initialverdi, kode, hovedformål, beskrivelse, kat_niva2
//     initialverdi, kode, datakilde, kat_niva1, kat_niva2
//   FROM klima.formål INNER JOIN klima.k4_ivkoder ON (initialverdi = arealformal)
//   -- WHERE initialverdi > 999
//   WHERE datakilde IN ('Kommuneplan', 'Reguleringsplan')
//   ORDER BY initialverdi;
// ) TO '/tmp/aux.csv' WITH CSV DELIMITER ';' HEADER;
const csv = `
initialverdi;kode;datakilde;kat_niva1;kat_niva2
100;Byggeområde;Kommuneplan;Bebygd;Bebygd
100;Byggeområde;Reguleringsplan;Bebygd;Bebygd
110;Boliger;Kommuneplan;Bebygd;Boligområde
110;Boliger;Reguleringsplan;Bebygd;Boligområde
111;Frittliggende småhusbebyggelse;Reguleringsplan;Bebygd;Boligområde - Spredt
112;Konsentrert småhusbebyggelse;Reguleringsplan;Bebygd;Boligområde - Tett
113;Blokkbebyggelse;Reguleringsplan;Bebygd;Boligområde - By
115;Garasje;Reguleringsplan;Bebygd;Boligområde - Tett
120;Forretning;Kommuneplan;Bebygd;Nærings- og institusjonsområde
120;Forretning;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
130;Kontor;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
130;Kontor;Kommuneplan;Bebygd;Nærings- og institusjonsområde
140;Industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
140;Industri;Kommuneplan;Bebygd;Fritidsboligområde
150;Fritidsbebyggelse;Kommuneplan;Bebygd;Nærings- og institusjonsområde
150;Fritidsbebyggelse;Reguleringsplan;Bebygd;Fritidsboligområde
160;Offentlig bebyggelse;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
160;Offentlig bebyggelse;Kommuneplan;Bebygd;Infrastruktur
162;Offentlig bygg - barnehage;Kommuneplan;Bebygd;Nærings- og institusjonsområde
162;Offentlig bygg - barnehage;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
163;Offentlig bygg - undervisning;Kommuneplan;Bebygd;Nærings- og institusjonsområde
163;Offentlig bygg - undervisning;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
164;Offentlig bygg - institusjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
166;Offentlig bygg - kirke;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
167;Offentlig bygg - forsamlingslokale;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
169;Offentlig bygg - administrativt bygg;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
170;Almennyttig formål;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
170;Almennyttig formål;Kommuneplan;Uklassifisert;Grøntområde
172;Almennyttig formål - barnehage;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
172;Almennyttig formål - barnehage;Kommuneplan;Bebygd;Grøntområde
173;Almennyttig formål - undervisning;Kommuneplan;Bebygd;Idrettsområde
173;Almennyttig formål - undervisning;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
174;Almennyttig formål - institusjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
176;Almennyttig formål - kirke;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
177;Almennyttig formål - forsamlingslokale;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
179;Almennyttig formål - administrativt bygg;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
180;Herberge og bevertningssted;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
181;Hotell;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
182;Bevertning;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
190;Garasjeanlegg/bensinstasjon;Kommuneplan;Bebygd;Bebygd
190;Garasjeanlegg/bensinstasjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
191;Garasjeanlegg;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
192;Bensinstasjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
199;Annet byggeområde;Reguleringsplan;Bebygd;Bebygd
200;Landbruksområde;Kommuneplan;Uklassifisert;Grunnkart - LNF
200;Landbruksområde;Reguleringsplan;Uklassifisert;Grunnkart - LNF
210;Jord- og skogbruk;Reguleringsplan;Uklassifisert;Grunnkart - LNF
210;Jord- og skogbruk;Kommuneplan;Uklassifisert;Grunnkart - LNF
220;Landbruksområde reindrift;Kommuneplan;Uklassifisert;Grunnkart - LNF
220;Landbruksområde reindrift;Reguleringsplan;Uklassifisert;Grunnkart - LNF
230;Gartneri;Reguleringsplan;Uklassifisert;Grunnkart - LNF
240;Parsellhage;Reguleringsplan;Uklassifisert;Grunnkart - LNF
299;Annet landbruksområde;Reguleringsplan;Uklassifisert;Grunnkart - LNF
300;Offentlig trafikkområde;Reguleringsplan;Bebygd;Samferdselsområde - Vei
300;Offentlig trafikkområde;Kommuneplan;Bebygd;Nærings- og institusjonsområde - Masseuttak
310;Kjørevei;Reguleringsplan;Bebygd;Samferdselsområde - Vei
310;Kjørevei;Kommuneplan;Bebygd;Nærings- og institusjonsområde - Masseuttak
311;Gate m/fortau;Reguleringsplan;Bebygd;Samferdselsområde - Vei
319;Annen veigrunn;Reguleringsplan;Bebygd;Samferdselsområde - Vei
320;Gang-/sykkelvei;Reguleringsplan;Bebygd;Samferdselsområde - Vei
320;Gang-/sykkelvei;Kommuneplan;Bebygd;Nærings- og institusjonsområde - Masseuttak
321;Sykkelvei;Reguleringsplan;Bebygd;Samferdselsområde - Vei
322;Gangvei;Reguleringsplan;Bebygd;Samferdselsområde - Vei
330;Gatetun;Reguleringsplan;Bebygd;Samferdselsområde - Vei
330;Gatetun;Kommuneplan;Uklassifisert;Grunnkart - LNF
331;Torg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
332;Rasteplass;Reguleringsplan;Bebygd;Samferdselsområde - Vei
333;Parkeringsplass;Reguleringsplan;Bebygd;Samferdselsområde - Vei
340;Kollektivanlegg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
341;Bussterminal;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
342;Bussholdeplass;Reguleringsplan;Bebygd;Samferdselsområde - Vei
343;Drosjeholdeplass;Reguleringsplan;Bebygd;Samferdselsområde - Vei
350;Jernbane;Reguleringsplan;Bebygd;Samferdselsområde - Bane
360;Sporvei/forstadsbane;Reguleringsplan;Bebygd;Samferdselsområde - Bane
370;Flyplass med administrasjonsbygg;Reguleringsplan;Bebygd;Samferdselsområde - Flyplass
371;Flyplass/taxebane;Reguleringsplan;Bebygd;Samferdselsområde - Flyplass
372;Hangarer, verksteder, admin. bygg;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
380;Havneområde;Reguleringsplan;Bebygd;Samferdselsområde - Havn
381;Kai;Reguleringsplan;Bebygd;Samferdselsområde - Havn
382;Småbåtanlegg;Reguleringsplan;Bebygd;Samferdselsområde - Havn
390;Trafikkområde i sjø og vassdrag;Reguleringsplan;Bebygd;Samferdselsområde - Havn
391;Skipsled;Reguleringsplan;Bebygd;Samferdselsområde - Havn
392;Havneområde i sjø;Reguleringsplan;Bebygd;Samferdselsområde - Havn
398;Annet trafikkområde i sjø/vassdrag;Reguleringsplan;Bebygd;Samferdselsområde - Havn
399;Annet trafikkområde;Reguleringsplan;Bebygd;Samferdselsområde - Havn
400;Offentlig friområde;Kommuneplan;Uklassifisert;Grunnkart - Båndegging
400;Offentlig friområde;Reguleringsplan;Uklassifisert;Grøntområde
410;Park;Kommuneplan;Uklassifisert;Grunnkart - Båndegging
410;Park;Reguleringsplan;Bebygd;Grøntområde
420;Turvei;Kommuneplan;Uklassifisert;Grunnkart - Båndegging
420;Turvei;Reguleringsplan;Bebygd;Grøntområde
421;Skiløype;Reguleringsplan;Bebygd;Idrettsområde - Skiløype
430;Anlegg for lek;Reguleringsplan;Bebygd;Grøntområde
440;Anlegg for idrett og sport;Reguleringsplan;Bebygd;Grøntområde
450;Leirplass;Reguleringsplan;Uklassifisert;Grøntområde
459;Annet friområde;Reguleringsplan;Uklassifisert;Grøntområde
460;Friområde i sjø og vassdrag;Reguleringsplan;Uklassifisert;Grøntområde
460;Friområde i sjø og vassdrag;Kommuneplan;Uklassifisert;Grunnkart - Forsvaret
462;Småbåthavn;Reguleringsplan;Bebygd;Samferdselsområde - Havn
463;Regattabane;Reguleringsplan;Bebygd;Idrettsområde
469;Annet friområde i sjø/vassdrag;Reguleringsplan;Uklassifisert;Grøntområde
600;Spesialområde;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
600;Spesialområde;Kommuneplan;Bebygd;Samferdselsområde - Havn
601;Privat veie;Reguleringsplan;Bebygd;Samferdselsområde - Vei
611;Parkbelte i industriområde;Reguleringsplan;Uklassifisert;Grøntområde
612;Campingplass;Reguleringsplan;Bebygd;Nærings- og institusjonsområde - Reiseliv (Camping/Hytter)
613;Friluftsområde;Reguleringsplan;Uklassifisert;Grøntområde
614;Friluftsområde i sjø/vassdrag;Reguleringsplan;Uklassifisert;Grøntområde
615;Idrettsanl., ikke offentlig tilgjengelig;Reguleringsplan;Bebygd;Idrettsområde
616;Golfbane;Reguleringsplan;Bebygd;Idrettsområde - Golfbane
617;Grav- og urnelund;Reguleringsplan;Bebygd;Gravlund
618;Privat småbåtanlegg;Reguleringsplan;Bebygd;Samferdselsområde - Havn
619;Privat småbåthavn;Reguleringsplan;Bebygd;Samferdselsområde - Havn
620;Anlegg i grunnen;Reguleringsplan;Bebygd;Infrastruktur
620;Anlegg i grunnen;Kommuneplan;Bebygd;Samferdselsområde - Vei
621;Kommunalteknisk virksomhet;Reguleringsplan;Bebygd;Infrastruktur
622;Drikkevannsmagasin;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
623;Vann- og avløpsanlegg;Reguleringsplan;Bebygd;Infrastruktur
624;Fjernvarmeanlegg;Reguleringsplan;Bebygd;Infrastruktur
625;Anlegg for telekommunikasjon;Reguleringsplan;Bebygd;Infrastruktur
626;Anlegg for forsvaret;Reguleringsplan;Uklassifisert;Grunnkart - Forsvaret
627;Anlegg for radionavigasjon;Reguleringsplan;Bebygd;Infrastruktur
630;Fiskebruk;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
630;Fiskebruk;Kommuneplan;Bebygd;Samferdselsområde - Vei
631;Andre anlegg i vassdrag/sjø;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
631;Andre anlegg i vassdrag/sjø;Kommuneplan;Bebygd;Samferdselsområde - Vei
650;Naturvernområde;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
650;Naturvernområde;Kommuneplan;Bebygd;Samferdselsområde - Bane
651;Naturvernområde i sjø/vassdrag;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
652;Klimavernsone;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
670;Steinbrudd og masseuttak;Reguleringsplan;Bebygd;Nærings- og institusjonsområde - Masseuttak
670;Steinbrudd og masseuttak;Kommuneplan;Bebygd;Samferdselsområde - Flyplass
671;Vesentlige terrenginngrep;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
680;Spesialområde reindrift;Kommuneplan;Bebygd;Samferdselsområde - Havn
680;Spesialområde reindrift;Reguleringsplan;Uklassifisert;Grunnkart - LNF
681;Pelsdyranlegg;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
685;Handlesgartneri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
690;Særskilt anlegg;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
691;Taubane;Reguleringsplan;Bebygd;Infrastruktur
692;Fornøyelsespark;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
693;Vindkraft;Reguleringsplan;Bebygd;Infrastruktur
699;Annet spesialområde;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
700;Fellesområde;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
710;Felles avkjørsel;Reguleringsplan;Bebygd;Samferdselsområde - Vei
720;Felles gangareal;Reguleringsplan;Bebygd;Samferdselsområde - Vei
730;Felles parkeringsplass;Reguleringsplan;Bebygd;Samferdselsområde - Vei
750;Felles lekeareal;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
760;Felles gårdsplass;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
770;Felles garasjeanlegg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
780;Felles grøntareal;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
790;Annet fellesareal;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
900;Kombinert formål;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
910;Bolig/Forretning;Reguleringsplan;Bebygd;Boligområde - Tett
911;Bolig/Forretning/Kontor;Reguleringsplan;Bebygd;Boligområde - By
912;Bolig/Kontor;Reguleringsplan;Bebygd;Boligområde - By
913;Bolig/Offentlig;Reguleringsplan;Bebygd;Boligområde - By
920;Forretning/Kontor;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
921;Forretning/Kontor/Industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
922;Forretning/Industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
923;Forretning/Kontor/Offentlig;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
924;Forretning/Offentlig;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
930;Kontor/Industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
931;Kontor/Offentlig;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
939;Kontor/Bensinstasjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
960;Offentlig/Almennyttig;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
980;Bevertning/Bensinstasjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
990;Annet kombinert formål;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
999;Unyansert formål;Reguleringsplan;Uklassifisert;Grunnkart - Spesialområder
1000;Bebyggelse og anlegg - generalisert (utgått);Kommuneplan;Bebygd;Bebygd
1001;Bebyggelse og anlegg;Kommuneplan;Bebygd;Bebygd
1001;Bebyggelse og anlegg;Reguleringsplan;Bebygd;Bebygd
1110;Boligbebyggelse;Reguleringsplan;Bebygd;Boligområde
1110;Boligbebyggelse;Kommuneplan;Bebygd;Boligområde
1111;Boligbebyggelse-frittliggende småhusbebyggelse;Reguleringsplan;Bebygd;Boligområde - Spredt
1112;Boligbebyggelse-konsentrert småhusbebyggelse;Reguleringsplan;Bebygd;Boligområde - Tett
1113;Boligbebyggelse-blokkbebyggelse;Reguleringsplan;Bebygd;Boligområde - By
1119;Garasjeanlegg for bolig-/fritidsbebyggelse;Reguleringsplan;Bebygd;Boligområde - Tett
1120;Fritidsbebyggelse;Reguleringsplan;Bebygd;Fritidsboligområde
1120;Fritidsbebyggelse;Kommuneplan;Bebygd;Fritidsboligområde
1121;Fritidsbebyggelse-frittliggende;Reguleringsplan;Bebygd;Fritidsboligområde
1122;Fritidsbebyggelse-konsentrert;Reguleringsplan;Bebygd;Fritidsboligområde
1123;Fritidsbebyggelse-blokk;Reguleringsplan;Bebygd;Fritidsboligområde
1124;Kolonihage;Reguleringsplan;Bebygd;Fritidsboligområde
1130;Sentrumsformål;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1130;Sentrumsformål;Kommuneplan;Bebygd;Nærings- og institusjonsområde
1140;Kjøpesenter;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1140;Kjøpesenter;Kommuneplan;Bebygd;Nærings- og institusjonsområde
1150;Forretninger;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1150;Forretninger;Kommuneplan;Bebygd;Nærings- og institusjonsområde
1160;Offentlig eller privat tjenesteyting;Kommuneplan;Bebygd;Nærings- og institusjonsområde
1160;Offentlig eller privat tjenesteyting;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1161;Barnehage;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1162;Undervisning;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1163;Institusjon (utgått);Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1164;Forsamlingslokale for religionsutøvelse;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1165;Forsamlingslokale (utgått);Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1166;Administrasjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1167;Kulturinstitusjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1168;Helse-/omsorgsinstitusjon;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1169;Annen offentlig eller privat tjenesteyting;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1170;Fritids- og turistformål;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1170;Fritids- og turistformål;Kommuneplan;Bebygd;Nærings- og institusjonsområde - Reiseliv (Camping/Hytter)
1171;Utleiehytter;Reguleringsplan;Bebygd;Nærings- og institusjonsområde - Reiseliv (Camping/Hytter)
1172;Fornøyelsespark eller temapark;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1173;Campingplass;Reguleringsplan;Bebygd;Nærings- og institusjonsområde - Reiseliv (Camping/Hytter)
1200;Råstoffutvinning;Kommuneplan;Bebygd;Nærings- og institusjonsområde - Masseuttak
1200;Råstoffutvinning;Reguleringsplan;Bebygd;Nærings- og institusjonsområde - Masseuttak
1201;Steinbrudd og masseuttak;Reguleringsplan;Bebygd;Nærings- og institusjonsområde - Masseuttak
1300;Næringsbebyggelse;Kommuneplan;Bebygd;Nærings- og institusjonsområde
1300;Næringsbebyggelse;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1310;Kontor;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1320;Hotell/overnatting;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1330;Bevertning;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1340;Industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1350;Lager;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1360;Bensinstasjon/vegserviceanlegg;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1390;Annen næring;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1400;Idrettsanlegg;Reguleringsplan;Bebygd;Idrettsområde
1400;Idrettsanlegg;Kommuneplan;Bebygd;Idrettsområde
1410;Skianlegg;Reguleringsplan;Bebygd;Idrettsområde
1420;Skiløypetrasé;Reguleringsplan;Bebygd;Idrettsområde - Skiløype
1430;Idrettsstadion;Reguleringsplan;Bebygd;Idrettsområde
1440;Nærmiljøanlegg;Reguleringsplan;Bebygd;Idrettsområde
1450;Golfbane;Reguleringsplan;Bebygd;Idrettsområde - Golfbane
1460;Motorsportanlegg;Reguleringsplan;Bebygd;Idrettsområde
1470;Skytebane;Reguleringsplan;Bebygd;Idrettsområde
1490;Andre idrettsanlegg;Reguleringsplan;Bebygd;Idrettsområde
1500;Andre typer bebyggelse og anlegg;Reguleringsplan;Bebygd;Bebygd
1500;Andre typer bebyggelse og anlegg;Kommuneplan;Bebygd;Bebygd
1501;Godsterminal;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
1502;Godslager;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
1510;Energianlegg;Reguleringsplan;Bebygd;Infrastruktur
1520;Fjernvarmeanlegg;Reguleringsplan;Bebygd;Infrastruktur
1520;Fjernvarmeanlegg;Reguleringsplan;Bebygd;Infrastruktur
1530;Vindkraftanlegg;Reguleringsplan;Bebygd;Infrastruktur
1540;Vann- og avløpanlegg;Reguleringsplan;Bebygd;Infrastruktur
1541;Vannforsyningsanlegg;Reguleringsplan;Bebygd;Infrastruktur
1542;Avløpsanlegg;Reguleringsplan;Bebygd;Infrastruktur
1550;Renovasjonsanlegg;Reguleringsplan;Bebygd;Infrastruktur
1560;Øvrige kommunaltekniske anlegg;Reguleringsplan;Bebygd;Infrastruktur
1570;Telekommunikasjonsanlegg;Reguleringsplan;Bebygd;Infrastruktur
1587;Småbåtanlegg i sjø og vassdrag;Reguleringsplan;Bebygd;Samferdselsområde - Havn
1588;Småbåtanlegg i sjø og vassdrag med tilhørende strandsone;Reguleringsplan;Bebygd;Samferdselsområde - Havn
1589;Uthus/naust/badehus;Reguleringsplan;Bebygd;Boligområde - Spredt
1590;Annen særskilt angitt bebyggelse og anlegg;Reguleringsplan;Bebygd;Bebygd
1600;Uteoppholdsareal;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
1600;Uteoppholdsareal;Kommuneplan;Bebygd;Grøntområde - Felles opphold
1610;Lekeplass;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
1620;Gårdsplass;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
1690;Annet uteoppholdsareal;Reguleringsplan;Bebygd;Grøntområde - Felles opphold
1700;Grav-og urnelund;Kommuneplan;Bebygd;Gravlund
1700;Grav-og urnelund;Reguleringsplan;Bebygd;Gravlund
1710;Krematorium;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1730;Nødvendige bygg og anlegg for grav- og urnelund;Reguleringsplan;Bebygd;Gravlund
1800;Kombinert bebyggelse og anleggsformål;Reguleringsplan;Bebygd;Bebygd
1800;Kombinert bebyggelse og anleggsformål;Kommuneplan;Bebygd;Nærings- og institusjonsområde
1801;Bolig/forretning;Reguleringsplan;Bebygd;Boligområde - By
1802;Bolig/forretning/kontor;Reguleringsplan;Bebygd;Boligområde - By
1803;Bolig/tjenesteyting;Reguleringsplan;Bebygd;Boligområde - By
1804;Bolig/kontor;Reguleringsplan;Bebygd;Boligområde - By
1810;Forretning/kontor;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1811;Forretning/kontor/industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1812;Forretning/industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1813;Forretning/kontor/tjenesteyting;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1814;Forretning/tjenesteyting;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1820;Næring/kontor (utgått);Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1821;Næring/kontor/industri (utgått);Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1822;Næring/industri (utgått);Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1823;Næring/kontor/tjenesteyting (utgått);Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1824;Næring/tjenesteyting;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1825;Kontor/lager;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1826;Industri/lager;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1830;Kontor/industri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1831;Kontor/tjenesteyting;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
1900;Angitt bebyggelse og anleggsformål kombinert med andre angitte hovedformål;Reguleringsplan;Bebygd;Bebygd
2000;Samferdselsanlegg og teknisk infrastruktur (arealer) - generalisert (utgått);Kommuneplan;Bebygd;Samferdselsområde - Infrastruktur
2001;Samferdselsanlegg og teknisk infrastruktur (arealer);Kommuneplan;Bebygd;Samferdselsområde - Infrastruktur
2001;Samferdselsanlegg og teknisk infrastruktur (arealer);Reguleringsplan;Bebygd;Samferdselsområde - Infrastruktur
2010;Veg;Kommuneplan;Bebygd;Samferdselsområde - Vei
2010;Veg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2011;Kjøreveg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2012;Fortau;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2013;Torg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2014;Gatetun;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2015;Gang-/sykkelveg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2016;Gangveg/gangareal/gågate;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2017;Sykkelanlegg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2018;Annen veggrunn - tekniske anlegg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2019;Annen veggrunn - grøntareal;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2020;Bane (nærmere angitt baneformål);Kommuneplan;Bebygd;Samferdselsområde - Bane
2020;Bane (nærmere angitt baneformål);Reguleringsplan;Bebygd;Samferdselsområde - Bane
2021;Trasé for jernbane;Reguleringsplan;Bebygd;Samferdselsområde - Bane
2022;Trasé for sporveg/forstadsbane;Reguleringsplan;Bebygd;Samferdselsområde - Bane
2023;Trasé for taubane;Reguleringsplan;Bebygd;Samferdselsområde - Infrastruktur
2024;Stasjons-/terminalbygg;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
2025;Holdeplass/plattform;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2026;Leskur/plattformtak;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2027;Tekniske bygg/konstruksjoner;Reguleringsplan;Bebygd;Samferdselsområde - Infrastruktur
2028;Annen banegrunn - tekniske anlegg;Reguleringsplan;Bebygd;Samferdselsområde - Bane
2029;Annen banegrunn - grøntareal;Reguleringsplan;Bebygd;Samferdselsområde - Bane
2030;Lufthavn generelt;Reguleringsplan;Bebygd;Samferdselsområde - Flyplass
2030;Lufthavn generelt;Kommuneplan;Bebygd;Samferdselsområde - Flyplass
2031;Lufthavn - landings-/taxebane;Reguleringsplan;Bebygd;Samferdselsområde - Flyplass
2032;Lufthavn - terminalbygg;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
2033;Lufthavn- hangarer/administrasjonsbygg;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
2034;Landingsplass for helikopter o.a.;Reguleringsplan;Bebygd;Samferdselsområde - Flyplass
2040;Havn;Reguleringsplan;Bebygd;Samferdselsområde - Havn
2040;Havn;Kommuneplan;Bebygd;Samferdselsområde - Havn
2041;Kai;Reguleringsplan;Bebygd;Samferdselsområde - Havn
2042;Havneterminaler;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
2043;Havnelager;Reguleringsplan;Bebygd;Samferdselsområde - Havn
2044;Molo;Kommuneplan;Bebygd;Samferdselsområde - Havn
2044;Molo;Reguleringsplan;Bebygd;Samferdselsområde - Havn
2045;Navigasjonsinstallasjon;Reguleringsplan;Bebygd;Samferdselsområde - Infrastruktur
2050;Hovednett for sykkel;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2050;Hovednett for sykkel;Kommuneplan;Bebygd;Samferdselsområde - Vei
2060;Kollektivnett;Kommuneplan;Bebygd;Samferdselsområde - Vei
2060;Kollektivnett;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2061;Trase for nærmere angitt kollektivtransport;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2070;Kollektivknutepunkt;Kommuneplan;Bebygd;Samferdselsområde - Vei
2070;Kollektivknutepunkt;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2071;Kollektivanlegg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2072;Kollektivterminal;Reguleringsplan;Bebygd;Samferdselsområde - Terminal
2073;Kollektivholdeplass;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2074;Pendler-/innfartsparkering;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2080;Parkering;Kommuneplan;Bebygd;Samferdselsområde - Vei
2080;Parkering;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2081;Rasteplass;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2082;Parkeringsplasser;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2083;Parkeringshus/-anlegg;Reguleringsplan;Bebygd;Samferdselsområde - Vei
2100;Trase for teknisk infrastruktur (utgått);Reguleringsplan;Bebygd;Infrastruktur
2100;Trase for teknisk infrastruktur (utgått);Kommuneplan;Bebygd;Infrastruktur
2101;Teknisk infrastruktur;Reguleringsplan;Bebygd;Infrastruktur
2110;Energinett;Reguleringsplan;Bebygd;Infrastruktur
2140;Vann- og avløpsnett;Reguleringsplan;Bebygd;Infrastruktur
2141;Vannforsyningsnett;Reguleringsplan;Bebygd;Infrastruktur
2142;Avløpsnett;Reguleringsplan;Bebygd;Infrastruktur
2143;Overvannsnett;Reguleringsplan;Bebygd;Infrastruktur
2150;Avfallssug;Reguleringsplan;Bebygd;Infrastruktur
2160;Telekommunikasjonsnett;Reguleringsplan;Bebygd;Infrastruktur
2170;Sikringsanlegg;Reguleringsplan;Bebygd;Infrastruktur
2180;Andre tekniske infrastrukturtraseer ;Reguleringsplan;Bebygd;Infrastruktur
2190;Kombinerte tekniske infrastrukturtraseer ;Reguleringsplan;Bebygd;Infrastruktur
2800;Kombinerte formål for samferdselsanlegg og/eller teknisk infrastrukturtraseer;Kommuneplan;Bebygd;Samferdselsområde - Infrastruktur
2800;Kombinerte formål for samferdselsanlegg og/eller teknisk infrastrukturtraseer;Reguleringsplan;Bebygd;Infrastruktur
2900;Angitte samferdselsanlegg og/eller teknisk infrastrukturtraseer kombinert med andre angitte hovedformål;Reguleringsplan;Bebygd;Infrastruktur
3000;Grønnstruktur - generalisert (utgått);Kommuneplan;Uklassifisert;Grunnkart Grøntområde
3001;Blågrønnstruktur;Kommuneplan;Uklassifisert;Grunnkart Grøntområde
3001;Blågrønnstruktur;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
3002;Blågrønnstruktur;Kommuneplan;Uklassifisert;Grunnkart Grøntområde
3002;Blågrønnstruktur;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
3020;Naturområde - grønnstruktur;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
3020;Naturområde - grønnstruktur;Kommuneplan;Uklassifisert;Grunnkart Grøntområde
3030;Turdrag;Kommuneplan;Uklassifisert;Grøntområde
3030;Turdrag;Reguleringsplan;Uklassifisert;Grøntområde
3031;Turveg;Reguleringsplan;Bebygd;Grøntområde
3040;Friområde;Kommuneplan;Uklassifisert;Grøntområde
3040;Friområde;Reguleringsplan;Uklassifisert;Grøntområde
3041;Badeplass/-område;Reguleringsplan;Uklassifisert;Grøntområde
3050;Park;Kommuneplan;Bebygd;Grøntområde
3050;Park;Reguleringsplan;Bebygd;Grøntområde
3060;Vegetasjonsskjerm;Reguleringsplan;Uklassifisert;Grøntområde
3061;Vannspeil;Reguleringsplan;Uklassifisert;Grøntområde
3100;Overvannstiltak;Reguleringsplan;Uklassifisert;Grøntområde
3100;Overvannstiltak;Kommuneplan;Uklassifisert;Grøntområde
3110;Infiltrasjon/fordrøyning/avledning;Reguleringsplan;Uklassifisert;Grøntområde
3800;Kombinerte grøntstrukturformål ;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
3800;Kombinerte grøntstrukturformål ;Kommuneplan;Uklassifisert;Grunnkart Grøntområde
3900;Angitt grøntstruktur kombinert med andre angitte hovedformål;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
4000;Forsvaret - generalisert (utgått);Kommuneplan;Uklassifisert;Grunnkart - Forsvaret
4001;Forsvaret;Reguleringsplan;Uklassifisert;Grunnkart - Forsvaret
4001;Forsvaret;Kommuneplan;Uklassifisert;Grunnkart - Forsvaret
4010;Ulike typer militære formål;Kommuneplan;Uklassifisert;Grunnkart - Forsvaret
4010;Ulike typer militære formål;Reguleringsplan;Uklassifisert;Grunnkart - Forsvaret
4020;Skytefelt/øvingsområde;Reguleringsplan;Uklassifisert;Grunnkart - Forsvaret
4020;Skytefelt/øvingsområde;Kommuneplan;Uklassifisert;Grunnkart - Forsvaret
4030;Forlegning/leir;Kommuneplan;Bebygd;Nærings- og institusjonsområde
4030;Forlegning/leir;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
4800;Kombinerte militærformål ;Reguleringsplan;Uklassifisert;Grunnkart - Forsvaret
4800;Kombinerte militærformål ;Kommuneplan;Uklassifisert;Grunnkart - Forsvaret
4900;Angitt militært formål kombinert med andre angitte hovedformål;Reguleringsplan;Uklassifisert;Grunnkart - Forsvaret
5000;Landbruks-, natur- og friluftsformål samt reindrift (LNFR) - generalisert (utgått);Kommuneplan;Uklassifisert;Grunnkart - LNF
5001;Landbruks-, natur- og friluftsformål samt reindrift (LNFR) (utgått);Kommuneplan;Uklassifisert;Grunnkart - LNF
5001;Landbruks-, natur- og friluftsformål samt reindrift (LNFR) (utgått);Reguleringsplan;Uklassifisert;Grunnkart - LNF
5100;LNFR areal for nødvendige tiltak for landbruk og reindrift og gårdstilknyttet næringsvirksomhet basert på gårdens ressursgrunnlag;Kommuneplan;Uklassifisert;Grunnkart - LNF
5100;LNFR areal for nødvendige tiltak for landbruk og reindrift og gårdstilknyttet næringsvirksomhet basert på gårdens ressursgrunnlag;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5110;Landbruksformål;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5111;Jordbruk;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5112;Skogbruk;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5113;Seterområde;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5114;Gartneri;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
5115;Pelsdyranlegg;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
5120;Naturformål av LNFR;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5130;Friluftsformål;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5140;Reindriftformål;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5200;LNFR areal for spredt bolig- fritids- eller næringsbebyggelse, mv ;Kommuneplan;Uklassifisert;Grunnkart - LNF
5200;LNFR areal for spredt bolig- fritids- eller næringsbebyggelse, mv ;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5210;Spredt boligbebyggelse;Kommuneplan;Uklassifisert;Grunnkart - LNF
5210;Spredt boligbebyggelse;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5220;Spredt  fritidsbebyggelse;Kommuneplan;Uklassifisert;Grunnkart - LNF
5220;Spredt  fritidsbebyggelse;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5230;Spredt  næringsbebyggelse;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
5230;Spredt  næringsbebyggelse;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5300;Naturvern;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5400;Jordvern;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5500;Særlige landskapshensyn;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5600;Vern av kulturmiljø eller kulturminne;Reguleringsplan;Uklassifisert;Grunnkart - LNF
5900;LNFR formål kombinert med andre angitte hovedformål;Reguleringsplan;Uklassifisert;Grunnkart - LNF
6000;Bruk og vern av sjø og vassdrag med tilhørende strandsone - generalisert (utgått);Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6001;Bruk og vern av sjø og vassdrag med tilhørende strandsone;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6001;Bruk og vern av sjø og vassdrag med tilhørende strandsone;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6100;Ferdsel;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6100;Ferdsel;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6110;Ankringsomåde;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6110;Ankringsomåde;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6120;Opplagsomåde;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6120;Opplagsomåde;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6130;Riggområde;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6130;Riggområde;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6200;Farled;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6200;Farled;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6211;Hoved-/biled;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6220;Havneområde i sjø;Kommuneplan;Bebygd;Samferdselsområde - Havn
6220;Havneområde i sjø;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6230;Småbåthavn;Reguleringsplan;Bebygd;Samferdselsområde - Havn
6230;Småbåthavn;Kommuneplan;Bebygd;Samferdselsområde - Havn
6240;Bøyehavn;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6300;Fiske;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6300;Fiske;Kommuneplan;Bebygd;Nærings- og institusjonsområde
6310;Fiskeområde;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
6320;Låssettingsplasser;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6330;Oppvekstområde for yngel;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6400;Akvakultur;Kommuneplan;Bebygd;Nærings- og institusjonsområde
6400;Akvakultur;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
6410;Akvakulturanlegg i sjø og vassdrag ;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
6420;Akvakulturanlegg i sjø og vassdrag med tilhørende strandsone;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
6430;Fangstbasert levendelagring;Reguleringsplan;Bebygd;Nærings- og institusjonsområde
6500;Drikkevann;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6500;Drikkevann;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6600;Naturområde;Kommuneplan;Uklassifisert;Grunnkart Grøntområde
6600;Naturområde;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
6610;Naturområde i sjø og vassdrag ;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
6620;Naturområde i sjø og vassdrag med tilhørende strandsone ;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
6700;Friluftsområde;Reguleringsplan;Uklassifisert;Grøntområde
6700;Friluftsområde;Kommuneplan;Uklassifisert;Grøntområde
6710;Friluftsområde i sjø og vassdrag ;Reguleringsplan;Uklassifisert;Grøntområde
6720;Friluftsområde i sjø og vassdrag med tilhørende strandsone ;Reguleringsplan;Uklassifisert;Grøntområde
6730;Småbåtanlegg i sjø og vassdrag (utgått);Reguleringsplan;Bebygd;Samferdselsområde - Havn
6740;Småbåtanlegg i sjø og vassdrag med tilhørende strandsone (utgått);Reguleringsplan;Bebygd;Samferdselsområde - Havn
6750;Uthus/naust/badehus (utgått);Reguleringsplan;Bebygd;Boligområde - Spredt
6760;Idrett/vannsport;Reguleringsplan;Bebygd;idrettsområde
6770;Badeområde;Reguleringsplan;Uklassifisert;Grunnkart Grøntområde
6800;Kombinerte formål i sjø og vassdrag med eller uten tilhørende strandsone;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6800;Kombinerte formål i sjø og vassdrag med eller uten tilhørende strandsone;Kommuneplan;Uklassifisert;Grunnkart - Sjø og vassdrag
6900;Angitt formål i sjø og vassdrag med eller uten tilhørende strandsone kombinert med andre angitte hovedformål;Reguleringsplan;Uklassifisert;Grunnkart - Sjø og vassdrag
9000;Solcelleanlegg;Reguleringsplan;Bebygd;Infrastruktur
9000;Solcelleanlegg;Kommuneplan;Bebygd;Infrastruktur
`;
